<template>
  <div class="addClass">
    <el-card>
      <div class="addClass-buttonBox">
        <div class="addClass-bar" style="margin-top: 6px">1</div>
        <div style="margin-top: 8px; width: 200px; margin-left: 5px">
          设置教学计划、开课时间
        </div>
        <div
          :class="
            tag.scheduleSettingState == 1
              ? 'addClass-buttonType addClass-buttonType2'
              : 'addClass-buttonType'
          "
          v-for="tag in tags"
          :key="tag.id"
          @click="classSetting(tag)"
          @mousemove="tag.show = true"
          @mouseleave="tag.show = false"
        >
          <div class="addClass-name">{{ tag.name }}({{ tag.type }})</div>
          <i
            v-if="tag.show"
            class="icon-close-style el-icon-close"
            @click.stop="handleClose(tag)"
          ></i>
        </div>
        <div></div>
      </div>
      <div class="addClass-buttonBox" style="margin-top: 20px">
        <div class="addClass-bar" style="margin-top: 6px">2</div>
        <div style="margin-top: 8px; width: 200px; margin-left: 5px">
          设置每周上课时间
        </div>
        <!-- <el-button
          type="primary"
          size="small"
          @click="periodPageList(),timeDialogVisible = true"
        >时间段</el-button> -->
        <el-button type="primary" size="small" @click="getScheduleTree()"
          >禁固排</el-button
        >
      </div>
      <div class="addClass-buttonBox" style="margin-top: 30px">
        <div class="addClass-bar" style="margin-top: 6px">3</div>
        <div style="margin-top: 8px; width: 200px; margin-left: 5px">
          前两步设置完成后生成课表
        </div>
        <el-button
          class="addClass-generate"
          type="primary"
          size="small"
          :loading="generateSimpleClassInfoScheduleBlock"
          @click="generateSimpleClassInfoSchedule()"
          >生成课表</el-button
        >
      </div>
      <!-- <div>排课预设置（第一步）</div>
      <el-tag
        class="addClass-tag"px
        @click="classSetting(tag)"
        v-for="tag in tags"
        :key="tag.id"
        closable
        @close="handleClose(tag)"
      >{{tag.name}}({{tag.type}})</el-tag>
      <div>排课条件（第二步）</div>
      <div class="addClass-button">
        <el-button
          type="primary"
          size="small"
          @click="periodPageList(),timeDialogVisible = true"
        >时间段</el-button>
        <el-button type="primary" size="small" @click="getScheduleTree()">禁固排</el-button>
      </div>
      <div>教室实况（第三步）</div>

      <el-button
        class="addClass-generate"
        type="primary"
        size="small"
        @click="generateSimpleClassInfoSchedule"
      >设置完成，生成排课</el-button>-->
      <el-tabs
        type="card"
        style="margin-top: 20px"
        v-model="activeName"
        @tab-click="handleClick"
      >
        <el-tab-pane label="周" name="first">
          <el-button-group class="calendar-button">
            <el-button size="small" class="calendar-button1" @click="lastWeek"
              >上一周</el-button
            >
            <el-button size="small" class="calendar-button1" @click="nowWeek"
              >今天</el-button
            >
            <el-button size="small" class="calendar-button1" @click="nextWeek"
              >下一周</el-button
            >
          </el-button-group>
          <el-calendar :range="currentWeekDate">
            <template slot="dateCell" slot-scope="{ date, data }">
              <div :class="data.isSelected ? 'is-selected' : ''">
                {{ data.day.split('-').slice(2).join('-') }}
              </div>
              <div v-for="(item, index) in calendarData" :key="index">
                <div
                  v-if="
                    item.date
                      .split('-')[1]
                      .indexOf(data.day.split('-').slice(1)[0]) != -1
                  "
                >
                  <div
                    v-if="
                      item.date
                        .split('-')[2]
                        .indexOf(data.day.split('-').slice(2).join('-')) != -1
                    "
                  >
                    <div v-for="(items, indexs) in item.data" :key="indexs">
                      <el-tooltip class="item" effect="light" placement="top">
                        <div slot="content">
                          <div class="calendar-solt1">
                            {{
                              items.subjectCourse.name +
                              '-第' +
                              items.sequence +
                              '课时'
                            }}
                          </div>
                          <div class="calendar-solt2">
                            上课时间:{{ items.schedulePeriod.beginTime }}-{{
                              items.schedulePeriod.endTime
                            }}
                          </div>
                          <div class="calendar-solt2">
                            上课老师:{{ items.teacher.name }}
                          </div>
                          <div class="calendar-solt2">
                            上课教室:{{ items.classroom.name }}
                          </div>
                        </div>
                        <div class="classManage-study1" type="size">
                          {{ items.classInfo.name
                          }}{{ items.subjectCourse.name }}
                        </div>
                      </el-tooltip>
                    </div>

                    <el-tooltip class="item" effect="light" placement="right">
                      <div slot="content" class="tooltip-height">
                        <div
                          class="calendar-solt2"
                          v-for="(itemss, index) in item.freeClassroom"
                          :key="index"
                        >
                          {{ itemss.name }}-{{ itemss.campusName }}
                        </div>
                      </div>
                      <div
                        v-if="item.classInfoCount <= 5"
                        class="is-selected classManage-study2"
                      >
                        剩余:{{ item.freeClassroomCount }}
                      </div>
                      <div v-else class="is-selected classManage-study3">
                        剩余:{{ item.freeClassroomCount }}
                      </div>
                    </el-tooltip>
                  </div>
                </div>
              </div>
            </template>
          </el-calendar>
        </el-tab-pane>
        <el-tab-pane label="月" name="second">
          <el-calendar v-model="currentDate">
            <template slot="dateCell" slot-scope="{ date, data }">
              <div :class="data.isSelected ? 'is-selected' : ''">
                {{ data.day.split('-').slice(2).join('-') }}
              </div>
              <div v-for="(item, index) in calendarData" :key="index">
                <div
                  v-if="
                    item.date
                      .split('-')[1]
                      .indexOf(data.day.split('-').slice(1)[0]) != -1
                  "
                >
                  <div
                    v-if="
                      item.date
                        .split('-')[2]
                        .indexOf(data.day.split('-').slice(2).join('-')) != -1
                    "
                  >
                    <div v-for="(items, indexs) in item.data" :key="indexs">
                      <el-tooltip class="item" effect="light" placement="top">
                        <div slot="content">
                          <div class="calendar-solt1">
                            {{
                              items.subjectCourse.name +
                              '-第' +
                              items.sequence +
                              '课时'
                            }}
                          </div>
                          <div class="calendar-solt2">
                            上课时间:{{ items.schedulePeriod.beginTime }}-{{
                              items.schedulePeriod.endTime
                            }}
                          </div>
                          <div class="calendar-solt2">
                            上课老师:{{ items.teacher.name }}
                          </div>
                          <div class="calendar-solt2">
                            上课教室:{{ items.classroom.name }}
                          </div>
                        </div>
                        <div class="classManage-study1" type="size">
                          {{ items.classInfo.name
                          }}{{ items.subjectCourse.name }}
                        </div>
                      </el-tooltip>
                    </div>
                    <div>
                      <el-tooltip class="item" effect="light" placement="right">
                        <div slot="content" class="tooltip-height">
                          <div
                            class="calendar-solt2"
                            v-for="(itemss, index) in item.freeClassroom"
                            :key="index"
                          >
                            {{ itemss.name }}-{{ itemss.campusName }}
                          </div>
                        </div>
                        <div
                          v-if="item.classInfoCount < 5"
                          class="is-selected classManage-study2"
                        >
                          剩余:{{ item.freeClassroomCount }}
                        </div>
                        <div v-else class="is-selected classManage-study3">
                          剩余:{{ item.freeClassroomCount }}
                        </div>
                      </el-tooltip>
                    </div>
                  </div>
                </div>
              </div>
            </template>
          </el-calendar>
        </el-tab-pane>
      </el-tabs>
    </el-card>

    <el-dialog
      class="addDialog"
      title="排课预设置"
      width="30%"
      :visible.sync="classSttingAddDialog"
    >
      <el-form
        :model="form"
        status-icon
        :rules="rules"
        ref="form"
        label-width="80px"
        class="demo-ruleForm"
      >
        <!-- <el-form-item label="校区" prop="campusId">
          <el-cascader
            style="width:90%;"
            clearable
            v-model="form.campusId"
            :show-all-levels="false"
            :props="CampusProps"
            placeholder="请选择所属校区"
            :options="campusList"
            @change="campusIdChange()"
          ></el-cascader>
        </el-form-item>-->
        <el-form-item label="教学计划" prop="planId">
          <el-select
            placeholder="请选择教学计划"
            style="width: 90%"
            v-model="form.planId"
            clearable
          >
            <el-option
              v-for="item in planList"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            ></el-option>
          </el-select>
          <el-button type="text" @click="goAddTeachingPlan">添加</el-button>
        </el-form-item>
        <el-form-item label="开课时间" prop="period">
          <el-date-picker
            style="width: 90%"
            v-model="form.period"
            format="yyyy-MM-dd"
            value-format="yyyy-MM-dd"
            type="daterange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
          ></el-date-picker>
        </el-form-item>
        <el-form-item label="上课老师" prop="teacherId">
          <el-select
            placeholder="请选择上课老师"
            style="width: 90%"
            v-model="form.teacherId"
            clearable
          >
            <el-option
              v-for="item in teacherList"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            ></el-option>
          </el-select>
          <el-button type="text" @click="goAddTeacher">添加</el-button>
        </el-form-item>
        <el-form-item label="教室" prop="classroomId">
          <el-select
            placeholder="请选择教室"
            style="width: 90%"
            v-model="form.classroomId"
            clearable
          >
            <el-option
              v-for="item in classroomList"
              :key="item.id"
              :label="item.name + '(' + item.campusName + ')'"
              :value="item.id"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="备注" prop="remark">
          <el-input
            style="width: 90%"
            v-model="form.remark"
            maxlength="200"
            clearable
          ></el-input>
        </el-form-item>
        <el-form-item>
          <el-button @click="classSttingAddDialog = false">取消</el-button>
          <el-button type="primary" @click="addScheduleSetting()"
            >提交</el-button
          >
        </el-form-item>
      </el-form>
    </el-dialog>

    <el-dialog title="时间段" :visible.sync="timeDialogVisible" width="40%">
      <el-dialog
        width="25%"
        :title="innerTitle"
        :visible.sync="innerVisible"
        append-to-body
      >
        <el-row>
          <el-col :span="11">
            <el-time-select
              style="width: 100%"
              placeholder="起始时间"
              v-model="periodForm.beginTime"
              :picker-options="{
                start: '06:00',
                step: '00:15',
                end: '24:00',
              }"
            ></el-time-select>
          </el-col>
          <el-col :span="2">
            <div class="time-selectType">至</div>
          </el-col>
          <el-col :span="11">
            <el-time-select
              style="width: 100%"
              placeholder="结束时间"
              v-model="periodForm.endTime"
              :picker-options="{
                start: '06:00',
                step: '00:15',
                end: '24:00',
                minTime: periodForm.beginTime,
              }"
            ></el-time-select>
          </el-col>
        </el-row>
        <div slot="footer" class="dialog-footer">
          <el-button @click="innerVisible = false">取消</el-button>
          <el-button type="primary" @click="addSchedulePeriod">提交</el-button>
        </div>
      </el-dialog>
      <el-button
        type="primary"
        @click=";(innerVisible = true), (innerTitle = '添加时间段')"
        >设置时间段</el-button
      >
      <el-table :data="periodList" border style="width: 100%; margin-top: 20px">
        <el-table-column prop="name" label="时间段">
          <template slot-scope="scope"
            >{{ scope.row.beginTime }}至{{ scope.row.endTime }}</template
          >
        </el-table-column>
        <!-- <el-table-column label="操作" width="120" align="center">
          <template slot-scope="scope">
            <i class="addClass-icon el-icon-edit" @click="getSchedulePeriod(scope.row.id)"></i>
            <i class="addClass-icon el-icon-delete" @click="deleteSchedulePeriod(scope.row.id)"></i>
          </template>
        </el-table-column>-->
      </el-table>
    </el-dialog>

    <el-dialog
      title="禁固排设置"
      :visible.sync="rowDialogVisible"
      width="900px"
      :close-on-click-modal="false"
    >
      <div class="addClass-gupai">
        <div class="rowStyle3"></div>
        <div class="rowStyle3-text">固定排课</div>
        <div class="rowStyle4"></div>
        <div class="rowStyle3-text" style="margin-right: auto">禁止排课</div>
      </div>
      <div style="display: flex">
        <div style="width: 20%">
          <!-- <div v-for="(item,index) in jump" :key="index" class="classInfoType">{{item.name}}</div> -->
          <el-tree
            :data="ClassInfoTreeList"
            :props="ChapterProps"
            current-node-key
            :highlight-current="true"
            :default-expanded-keys="['1']"
            :expand-on-click-node="false"
            class="classManage-tree"
            ref="tree"
            node-key="id"
          >
            <span
              class="span-ellipsis"
              slot-scope="{ node, data }"
              @click="handleNodeClick(data, node.level, 1)"
            >
              <span :title="data.name + '(' + data.type + ')'">
                <!-- <span v-if="data.scheduleRuleState==-1" class="el-icon-check"></span> -->
                {{ data.name }}({{ data.type }})
              </span>
            </span>
          </el-tree>
          <!-- <el-tree
            :data="TeacherTreeList"
            :props="ChapterProps"
            accordion
            :expand-on-click-node="false"
            class="classManage-tree"
          >
            <span
              class="span-ellipsis"
              slot-scope="{ node, data }"
              @click="handleNodeClick(data,node.level,2)"
            >
              <span :title="data.name">{{ data.name }}</span>
            </span>
          </el-tree>
          <el-tree
            :data="ClassroomTreeList"
            :props="ChapterProps"
            accordion
            :expand-on-click-node="false"
            class="classManage-tree"
          >
            <span
              class="span-ellipsis"
              slot-scope="{ node, data }"
              @click="handleNodeClick(data,node.level,3)"
            >
              <span :title="data.name">{{ data.name }}</span>
            </span>
          </el-tree>-->
        </div>
        <div style="width: 80%">
          <div style="display: flex; justify-content: space-between">
            <div>
              <el-radio
                class="rowStyle3-text"
                v-model="radio"
                label="1"
                @change="radioChange"
                >固定排课</el-radio
              >
              <el-radio
                class="rowStyle3-text"
                v-model="radio"
                label="2"
                @change="radioChange"
                >禁止排课</el-radio
              >
            </div>
            <el-button sty type="primary" size="small" @click="scheduleRuletrue"
              >保存</el-button
            >
          </div>
          <div style="display: flex"></div>
          <el-table :data="rowTableData" border style="margin-top: 10px">
            <el-table-column
              prop="period"
              label="时间段"
              width="90"
            ></el-table-column>
            <el-table-column prop="monday" label="周一" align="center">
              <template slot-scope="scope">
                <div
                  class="table-row"
                  @mousemove="scope.row.mondayTem = 1"
                  @mouseleave="scope.row.mondayTem = -1"
                >
                  <div
                    class="table-cell"
                    v-if="
                      (scope.row.monday === 2 || scope.row.mondayTem === 1) &&
                      radioForbidden === 2
                    "
                    @click="scheduleRuleChange(scope.row, 2, 2)"
                  >
                    <div class="rowStyle1"></div>
                  </div>
                  <div
                    class="table-cell"
                    v-if="
                      (scope.row.monday === 1 || scope.row.mondayTem === 1) &&
                      radioForbidden === 1
                    "
                    @click="scheduleRuleChange(scope.row, 2, 1)"
                  >
                    <div class="rowStyle2"></div>
                  </div>
                  <!-- <div
                    v-if="(scope.row.monday===1||scope.row.monday===2)&&scope.row.mondayTem===1"
                    class="el-icon-close"
                    @click="scope.row.monday=-1,scheduleRuleChange(scope.row,2,-1)"
                  ></div>-->
                </div>
              </template>
            </el-table-column>
            <el-table-column prop="tuesday" label="周二" align="center">
              <template slot-scope="scope">
                <div
                  class="table-row"
                  @mousemove="scope.row.tuesdayTem = 1"
                  @mouseleave="scope.row.tuesdayTem = -1"
                >
                  <div
                    class="table-cell"
                    v-if="
                      (scope.row.tuesday === 2 || scope.row.tuesdayTem === 1) &&
                      radioForbidden === 2
                    "
                    @click="scheduleRuleChange(scope.row, 3, 2)"
                  >
                    <div class="rowStyle1"></div>
                  </div>
                  <div
                    class="table-cell"
                    v-if="
                      (scope.row.tuesday === 1 || scope.row.tuesdayTem === 1) &&
                      radioForbidden === 1
                    "
                    @click="scheduleRuleChange(scope.row, 3, 1)"
                  >
                    <div class="rowStyle2"></div>
                  </div>
                  <!-- <div
                    v-if="(scope.row.tuesday===1||scope.row.tuesday===2)&&scope.row.tuesdayTem===1"
                    class="el-icon-close"
                    @click="scope.row.tuesday=-1,scheduleRuleChange(scope.row,3,-1)"
                  ></div>-->
                </div>
              </template>
            </el-table-column>
            <el-table-column prop="wednesday" label="周三" align="center">
              <template slot-scope="scope">
                <div
                  class="table-row"
                  @mousemove="scope.row.wednesdayTem = 1"
                  @mouseleave="scope.row.wednesdayTem = -1"
                >
                  <div
                    class="table-cell"
                    v-if="
                      (scope.row.wednesday === 2 ||
                        scope.row.wednesdayTem === 1) &&
                      radioForbidden === 2
                    "
                    @click="scheduleRuleChange(scope.row, 4, 2)"
                  >
                    <div class="rowStyle1"></div>
                  </div>
                  <div
                    class="table-cell"
                    v-if="
                      (scope.row.wednesday === 1 ||
                        scope.row.wednesdayTem === 1) &&
                      radioForbidden === 1
                    "
                    @click="scheduleRuleChange(scope.row, 4, 1)"
                  >
                    <div class="rowStyle2"></div>
                  </div>
                  <!-- <div
                    v-if="(scope.row.wednesday===1||scope.row.wednesday===2)&&scope.row.wednesdayTem===1"
                    class="el-icon-close"
                    @click="scope.row.wednesday=-1,scheduleRuleChange(scope.row,4,-1)"
                  ></div>-->
                </div>
              </template>
            </el-table-column>
            <el-table-column prop="thursday" label="周四" align="center">
              <template slot-scope="scope">
                <div
                  class="table-row"
                  @mousemove="scope.row.thursdayTem = 1"
                  @mouseleave="scope.row.thursdayTem = -1"
                >
                  <div
                    class="table-cell"
                    v-if="
                      (scope.row.thursday === 2 ||
                        scope.row.thursdayTem === 1) &&
                      radioForbidden === 2
                    "
                    @click="scheduleRuleChange(scope.row, 5, 2)"
                  >
                    <div class="rowStyle1"></div>
                  </div>
                  <div
                    class="table-cell"
                    v-if="
                      (scope.row.thursday === 1 ||
                        scope.row.thursdayTem === 1) &&
                      radioForbidden === 1
                    "
                    @click="scheduleRuleChange(scope.row, 5, 1)"
                  >
                    <div class="rowStyle2"></div>
                  </div>
                  <!-- <div
                    v-if="(scope.row.thursday===1||scope.row.thursday===2)&&scope.row.thursdayTem===1"
                    class="el-icon-close"
                    @click="scope.row.thursday=-1,scheduleRuleChange(scope.row,5,-1)"
                  ></div>-->
                </div>
              </template>
            </el-table-column>
            <el-table-column prop="friday" label="周五" align="center">
              <template slot-scope="scope">
                <div
                  class="table-row"
                  @mousemove="scope.row.fridayTem = 1"
                  @mouseleave="scope.row.fridayTem = -1"
                >
                  <div
                    class="table-cell"
                    v-if="
                      (scope.row.friday === 2 || scope.row.fridayTem === 1) &&
                      radioForbidden === 2
                    "
                    @click="scheduleRuleChange(scope.row, 6, 2)"
                  >
                    <div class="rowStyle1"></div>
                  </div>
                  <div
                    class="table-cell"
                    v-if="
                      (scope.row.friday === 1 || scope.row.fridayTem === 1) &&
                      radioForbidden === 1
                    "
                    @click="scheduleRuleChange(scope.row, 6, 1)"
                  >
                    <div class="rowStyle2"></div>
                  </div>
                  <!-- <div
                    v-if="(scope.row.friday===1||scope.row.friday===2)&&scope.row.fridayTem===1"
                    class="el-icon-close"
                    @click="scope.row.friday=-1,scheduleRuleChange(scope.row,6,-1)"
                  ></div>-->
                </div>
              </template>
            </el-table-column>
            <el-table-column prop="saturday" label="周六" align="center">
              <template slot-scope="scope">
                <div
                  class="table-row"
                  @mousemove="scope.row.saturdayTem = 1"
                  @mouseleave="scope.row.saturdayTem = -1"
                >
                  <div
                    class="table-cell"
                    v-if="
                      (scope.row.saturday === 2 ||
                        scope.row.saturdayTem === 1) &&
                      radioForbidden === 2
                    "
                    @click="scheduleRuleChange(scope.row, 7, 2)"
                  >
                    <div class="rowStyle1"></div>
                  </div>
                  <div
                    class="table-cell"
                    v-if="
                      (scope.row.saturday === 1 ||
                        scope.row.saturdayTem === 1) &&
                      radioForbidden === 1
                    "
                    @click="scheduleRuleChange(scope.row, 7, 1)"
                  >
                    <div class="rowStyle2"></div>
                  </div>
                  <!-- <div
                    v-if="(scope.row.saturday===1||scope.row.saturday===2)&&scope.row.saturdayTem===1"
                    class="el-icon-close"
                    @click="scope.row.saturday=-1,scheduleRuleChange(scope.row,7,-1)"
                  ></div>-->
                </div>
              </template>
            </el-table-column>
            <el-table-column prop="sunday" label="周日" align="center">
              <template slot-scope="scope">
                <div
                  class="table-row"
                  @mousemove="scope.row.sundayTem = 1"
                  @mouseleave="scope.row.sundayTem = -1"
                >
                  <div
                    class="table-cell"
                    v-if="
                      (scope.row.sunday === 2 || scope.row.sundayTem === 1) &&
                      radioForbidden === 2
                    "
                    @click="scheduleRuleChange(scope.row, 1, 2)"
                    @dblclick="scheduleRuleChange(scope.row, 1, -1)"
                  >
                    <div class="rowStyle1"></div>
                  </div>
                  <div
                    class="table-cell"
                    v-if="
                      (scope.row.sunday === 1 || scope.row.sundayTem === 1) &&
                      radioForbidden === 1
                    "
                    @click="scheduleRuleChange(scope.row, 1, 1)"
                    @dblclick="scheduleRuleChange(scope.row, 1, -1)"
                  >
                    <div class="rowStyle2"></div>
                  </div>
                  <!-- <div
                    v-if="(scope.row.sunday===1||scope.row.sunday===2)&&scope.row.sundayTem===1"
                    class="el-icon-close"
                    @click="scope.row.sunday=-1,scheduleRuleChange(scope.row,1,-1)"
                  ></div>-->
                </div>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>
    </el-dialog>

    <el-dialog
      class=""
      title="添加教学计划"
      width="50%"
      :visible.sync="addTeachingPlanDialog"
      destroy-on-close
    >
      <div class="addTeachingPlanDialog">
        <taachPlay @handleClose2="handleClose2"></taachPlay>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import moment from "moment";
import taachPlay from "./addTeaching.vue";
export default {
  components: { taachPlay },
  data () {
    return {
      generateSimpleClassInfoScheduleBlock: false,
      activeName: "second",
      currentDate: new Date(),
      currentWeekDate: [
        moment(new Date())
          .startOf("week")
          .subtract(-1, "days")
          .format("YYYY-MM-DD"),
        moment(new Date())
          .endOf("week")
          .subtract(-1, "days")
          .format("YYYY-MM-DD")
      ],
      scheduleRuleTrue: false,
      nowTime: new Date(),
      calendarData: [],
      innerTitle: "添加时间段",
      tags: [],
      radio: "1",
      radioForbidden: 2,
      timeDialogVisible: false,
      innerVisible: false,
      getPeriodTrue: false,
      classSttingAddDialog: false,
      addTeachingPlanDialog: false,
      rowDialogVisible: false,
      rowtrue: false,
      updataTrue: false,
      campusList: [],
      CampusProps: {
        value: "id",
        children: "children",
        label: "name"
      },
      ChapterProps: {
        value: "id",
        children: "children",
        label: "name"
      },
      periodList: [],
      teacherList: [],
      classroomList: [],
      planList: [],
      rowTableData: [],
      weekdayTem: -1,
      periodPage: {
        pageNumber: 1,
        pageSize: 100
      },
      rowPage: {
        pageNumber: 1,
        pageSize: 100
      },
      jump: [],
      form: {},
      periodForm: {
        endTime: "",
        beginTime: ""
      },
      objectId: null,
      type: null,
      // scheduleRuleList: {
      //   scheduleRuleList: []
      // },
      scheduleRuleList: [],
      changeScheduleRuleList: [],
      scheduleRuleShow: [],
      addScheduleRuleTrue: true,
      ScheduleTrue: false,
      ScheduleTrueId: null,
      ClassInfoTreeList: [],
      TeacherTreeList: [],
      ClassroomTreeList: [],
      rules: {
        campusId: [
          {
            required: true,
            message: "请选择所属校区",
            trigger: "change"
          }
        ],
        planId: [
          {
            required: true,
            message: "请选择教学计划",
            trigger: "change"
          }
        ],
        period: [
          {
            required: true,
            message: "请选择开课时间",
            trigger: "change"
          }
        ]
      }
    };
  },
  methods: {
    getData () {
      this.jump = JSON.parse(localStorage.getItem("classDetail"));
      this.jump.forEach(item => {
        this.$set(item, "show", false);
      });
      this.tags = this.jump;
    },
    radioChange () {
      if (this.radio == 1) {
        this.radioForbidden = 2;
        this.scheduleRuleList.id = "";
        this.scheduleRuleList.scheduleRuleList = [];
      }
      if (this.radio == 2) {
        this.radioForbidden = 1;
        this.scheduleRuleList.id = "";
        this.scheduleRuleList.scheduleRuleList = [];
      }
    },
    periodPageList () {
      this.api.schedulePeriod
        .pageList(this.periodPage)
        .then(result => {
          if (result.success) {
            this.periodList = result.data.records;
          } else {
            this.$message.error(result.message);
          }
        })
        .catch(error => {
          console.log(error);
        });
    },
    addSchedulePeriod () {
      if (this.getPeriodTrue === false) {
        this.api.schedulePeriod
          .addSchedulePeriod(this.periodForm)
          .then(result => {
            if (result.success) {
              this.innerVisible = false;
              this.periodPageList();
            } else {
              this.$message.error(result.message);
            }
          })
          .catch(error => {
            console.log(error);
          });
      } else {
        this.api.schedulePeriod
          .updateSchedulePeriod(this.periodForm)
          .then(result => {
            if (result.success) {
              this.innerVisible = false;
              this.periodPageList();
            } else {
              this.$message.error(result.message);
            }
          })
          .catch(error => {
            console.log(error);
          });
      }
    },
    getSchedulePeriod (id) {
      this.api.schedulePeriod
        .getSchedulePeriod({ id: id })
        .then(result => {
          if (result.success) {
            this.innerTitle = "编辑时间段";
            this.periodForm = result.data;
            this.getPeriodTrue = true;
            this.innerVisible = true;
          } else {
            this.$message.error(result.message);
          }
        })
        .catch(error => {
          console.log(error);
        });
    },
    deleteSchedulePeriod (id) {
      this.$confirm("您确定要进行删除操作吗？", "系统消息", {
        type: "warning"
      }).then(() => {
        this.api.schedulePeriod
          .deleteSchedulePeriod([{ id: id }])
          .then(result => {
            if (result.success) {
              this.$message.success(result.message);
              this.periodPageList();
            } else {
              this.$message.error(result.message);
            }
          })
          .catch(error => {
            console.log(error);
          });
      });
    },

    getScheduleTree () {
      this.objectId = this.jump[0].id;
      this.type = 1;
      this.getClassInfoTree();
      this.getScheduleRuleList();
    },
    getScheduleRuleList () {
      let objectIdList = [];
      let weekdayTemTrue = false;
      this.changeScheduleRuleList = [];
      for (let item of JSON.parse(localStorage.getItem("classDetail"))) {
        objectIdList.push(item.id);
      }
      this.api.scheduleObject
        .getScheduleRuleList({ objectIdList })
        .then(result => {
          for (let item of result.data) {
            let obj = [];
            let obj8 = {};
            for (let i in item.scheduleRuleList) {
              item.scheduleRuleList[i].objectId = item.objectId;
              item.scheduleRuleList[i].mondayTem = -1;
              item.scheduleRuleList[i].tuesdayTem = -1;
              item.scheduleRuleList[i].wednesdayTem = -1;
              item.scheduleRuleList[i].thursdayTem = -1;
              item.scheduleRuleList[i].fridayTem = -1;
              item.scheduleRuleList[i].saturdayTem = -1;
              item.scheduleRuleList[i].sundayTem = -1;
              if (
                item.scheduleRuleList[i].monday == 1 ||
                item.scheduleRuleList[i].monday == 2
              ) {
                let obj1 = {
                  schedulePeriodId: item.scheduleRuleList[i].schedulePeriodId,
                  weekday: 2
                };
                obj.push(obj1);
              }
              if (
                item.scheduleRuleList[i].tuesday == 1 ||
                item.scheduleRuleList[i].tuesday == 2
              ) {
                let obj2 = {
                  schedulePeriodId: item.scheduleRuleList[i].schedulePeriodId,
                  weekday: 3
                };
                obj.push(obj2);
              }
              if (
                item.scheduleRuleList[i].wednesday == 1 ||
                item.scheduleRuleList[i].wednesday == 2
              ) {
                let obj3 = {
                  schedulePeriodId: item.scheduleRuleList[i].schedulePeriodId,
                  weekday: 4
                };
                obj.push(obj3);
              }
              if (
                item.scheduleRuleList[i].thursday == 1 ||
                item.scheduleRuleList[i].thursday == 2
              ) {
                let obj4 = {
                  schedulePeriodId: item.scheduleRuleList[i].schedulePeriodId,
                  weekday: 5
                };
                obj.push(obj4);
              }
              if (
                item.scheduleRuleList[i].friday == 1 ||
                item.scheduleRuleList[i].friday == 2
              ) {
                let obj5 = {
                  schedulePeriodId: item.scheduleRuleList[i].schedulePeriodId,
                  weekday: 6
                };
                obj.push(obj5);
              }
              if (
                item.scheduleRuleList[i].saturday == 1 ||
                item.scheduleRuleList[i].saturday == 2
              ) {
                let obj6 = {
                  schedulePeriodId: item.scheduleRuleList[i].schedulePeriodId,
                  weekday: 7
                };
                obj.push(obj6);
              }
              if (
                item.scheduleRuleList[i].sunday == 1 ||
                item.scheduleRuleList[i].sunday == 2
              ) {
                let obj7 = {
                  schedulePeriodId: item.scheduleRuleList[i].schedulePeriodId,
                  weekday: 1
                };
                obj.push(obj7);
              }
              obj8.id = item.id;
              obj8.objectId = item.objectId;
              obj8.scheduleType = item.scheduleType;
              obj8.scheduleRuleList = obj;
            }
            this.changeScheduleRuleList.push(obj8);
          }
          this.scheduleRuleList = result.data;
          for (let items of this.scheduleRuleList[0].scheduleRuleList) {
            if (
              items.monday === 1 ||
              items.tuesday === 1 ||
              items.wednesday === 1 ||
              items.thursday === 1 ||
              items.friday === 1 ||
              items.saturday === 1 ||
              items.sunday === 1
            ) {
              weekdayTemTrue = true;
              this.weekdayTem = 1;
              this.radio = "2";
              this.radioForbidden = 1;
            } else if (
              items.monday === 2 ||
              items.tuesday === 2 ||
              items.wednesday === 2 ||
              items.thursday === 2 ||
              items.friday === 2 ||
              items.saturday === 2 ||
              items.sunday === 2
            ) {
              weekdayTemTrue = true;
              this.weekdayTem = 2;
              this.radio = "1";
              this.radioForbidden = 2;
            }
          }
          if (weekdayTemTrue === false) {
            this.weekdayTem = -1;
          }
          if (weekdayTemTrue === false) {
            this.weekdayTem = -1;
          }
          this.rowTableData = this.scheduleRuleList[0].scheduleRuleList;
          this.rowDialogVisible = true;
          this.$nextTick(function () {
            this.$refs.tree.setCurrentKey(
              this.ClassInfoTreeList[0].children[0].id
            );
          });
        });
    },
    getSchedule (data) {
      // this.ScheduleTrue = false;
      // this.scheduleRuleShow = [];
      // this.scheduleRuleList = [];
      // // this.scheduleRuleList.scheduleRuleList = [];
      // let jump = JSON.parse(localStorage.getItem("classDetail"));
      // for (let res of jump) {
      //   console.log("333");
      //   this.api.scheduleObject
      //     .getSchedule({ objectId: res.id })
      //     .then(result => {
      //       let weekdayTemTrue = false;
      //       if (result.data === null) {
      //         this.rowDialogVisible = true;
      //         this.$message.error("返回值为空");
      //       }
      //       for (let i in result.data.scheduleRuleList) {
      //         result.data.scheduleRuleList[i].mondayTem = -1;
      //         result.data.scheduleRuleList[i].tuesdayTem = -1;
      //         result.data.scheduleRuleList[i].wednesdayTem = -1;
      //         result.data.scheduleRuleList[i].thursdayTem = -1;
      //         result.data.scheduleRuleList[i].fridayTem = -1;
      //         result.data.scheduleRuleList[i].saturdayTem = -1;
      //         result.data.scheduleRuleList[i].sundayTem = -1;
      //       }
      //       this.scheduleRuleList.push(result.data);
      //       for (let items of this.scheduleRuleList[0].scheduleRuleList) {
      //         if (
      //           items.monday === 1 ||
      //           items.tuesday === 1 ||
      //           items.wednesday === 1 ||
      //           items.thursday === 1 ||
      //           items.friday === 1 ||
      //           items.saturday === 1 ||
      //           items.sunday === 1
      //         ) {
      //           weekdayTemTrue = true;
      //           this.weekdayTem = 1;
      //           this.radio = "2";
      //           this.radioForbidden = 1;
      //         } else if (
      //           items.monday === 2 ||
      //           items.tuesday === 2 ||
      //           items.wednesday === 2 ||
      //           items.thursday === 2 ||
      //           items.friday === 2 ||
      //           items.saturday === 2 ||
      //           items.sunday === 2
      //         ) {
      //           weekdayTemTrue = true;
      //           this.weekdayTem = 2;
      //           this.radio = "1";
      //           this.radioForbidden = 2;
      //         }
      //       }
      //       this.rowTableData = this.scheduleRuleList[0].scheduleRuleList;
      //     });
      // }
      // this.rowDialogVisible = true;
      // console.log("this.scheduleRuleList", this.scheduleRuleList);
      // this.api.scheduleObject
      //   .getSchedule({ objectId: data })
      //   .then(result => {
      //     let weekdayTemTrue = false;
      //     if (result.success) {
      // if (result.data === null) {
      //   this.rowDialogVisible = true;
      //   this.$message.error("返回值为空");
      // }
      // if (result.data.id !== null) {
      //   this.ScheduleTrue = true;
      //   this.ScheduleTrueId = result.data.id;
      // }
      // for (let i in result.data.scheduleRuleList) {
      //   result.data.scheduleRuleList[i].mondayTem = -1;
      //   result.data.scheduleRuleList[i].tuesdayTem = -1;
      //   result.data.scheduleRuleList[i].wednesdayTem = -1;
      //   result.data.scheduleRuleList[i].thursdayTem = -1;
      //   result.data.scheduleRuleList[i].fridayTem = -1;
      //   result.data.scheduleRuleList[i].saturdayTem = -1;
      //   result.data.scheduleRuleList[i].sundayTem = -1;
      //   if (
      //     result.data.scheduleRuleList[i].monday === 1 ||
      //     result.data.scheduleRuleList[i].tuesday === 1 ||
      //     result.data.scheduleRuleList[i].wednesday === 1 ||
      //     result.data.scheduleRuleList[i].thursday === 1 ||
      //     result.data.scheduleRuleList[i].friday === 1 ||
      //     result.data.scheduleRuleList[i].saturday === 1 ||
      //     result.data.scheduleRuleList[i].sunday === 1
      //   ) {
      //     weekdayTemTrue = true;
      //     this.weekdayTem = 1;
      //     this.radio = "2";
      //     this.radioForbidden = 1;
      //   } else if (
      //     result.data.scheduleRuleList[i].monday === 2 ||
      //     result.data.scheduleRuleList[i].tuesday === 2 ||
      //     result.data.scheduleRuleList[i].wednesday === 2 ||
      //     result.data.scheduleRuleList[i].thursday === 2 ||
      //     result.data.scheduleRuleList[i].friday === 2 ||
      //     result.data.scheduleRuleList[i].saturday === 2 ||
      //     result.data.scheduleRuleList[i].sunday === 2
      //   ) {
      //     weekdayTemTrue = true;
      //     this.weekdayTem = 2;
      //     this.radio = "1";
      //     this.radioForbidden = 2;
      //   }
      // }
      // if (weekdayTemTrue === false) {
      //   this.weekdayTem = -1;
      // }
      // if (weekdayTemTrue === false) {
      //   this.weekdayTem = -1;
      // }
      //     this.rowTableData = result.data.scheduleRuleList;
      //     for (let items of this.scheduleRuleShow) {
      //       if (items.forbidden === 1 || items.forbidden === 2) {
      //         this.scheduleRuleList.scheduleRuleList.push(items);
      //       }
      //     }
      //     this.rowDialogVisible = true;
      //   } else {
      //     this.$message.error(result.message);
      //   }
      // })
      // .catch(error => {
      //   console.log(error);
      // });
      // if (weekdayTemTrue === false) {
      //   this.weekdayTem = -1;
      // }
      // if (weekdayTemTrue === false) {
      //   this.weekdayTem = -1;
      // }
      // for (let item of result.data.scheduleRuleList) {
      //   let obj1 = {
      //     forbidden: item.monday,
      //     schedulePeriodId: item.schedulePeriodId,
      //     weekday: 2
      //   };
      //   this.scheduleRuleShow.push(obj1);
      //   let obj2 = {
      //     forbidden: item.tuesday,
      //     schedulePeriodId: item.schedulePeriodId,
      //     weekday: 3
      //   };
      //   this.scheduleRuleShow.push(obj2);
      //   let obj3 = {
      //     forbidden: item.wednesday,
      //     schedulePeriodId: item.schedulePeriodId,
      //     weekday: 4
      //   };
      //   this.scheduleRuleShow.push(obj3);
      //   let obj4 = {
      //     forbidden: item.thursday,
      //     schedulePeriodId: item.schedulePeriodId,
      //     weekday: 5
      //   };
      //   this.scheduleRuleShow.push(obj4);
      //   let obj5 = {
      //     forbidden: item.friday,
      //     schedulePeriodId: item.schedulePeriodId,
      //     weekday: 6
      //   };
      //   this.scheduleRuleShow.push(obj5);
      //   let obj6 = {
      //     forbidden: item.saturday,
      //     schedulePeriodId: item.schedulePeriodId,
      //     weekday: 7
      //   };
      //   this.scheduleRuleShow.push(obj6);
      //   let obj7 = {
      //     forbidden: item.sunday,
      //     schedulePeriodId: item.schedulePeriodId,
      //     weekday: 1
      //   };
      //   this.scheduleRuleShow.push(obj7);
      // }
    },

    handleNodeClick (data, level, type) {
      if (level !== 1) {
        this.objectId = data.id;
        this.type = type;
        let weekdayTemTrue = false;
        for (let item of this.scheduleRuleList) {
          if (data.id === item.objectId) {
            for (let items of item.scheduleRuleList) {
              if (
                items.monday === 1 ||
                items.tuesday === 1 ||
                items.wednesday === 1 ||
                items.thursday === 1 ||
                items.friday === 1 ||
                items.saturday === 1 ||
                items.sunday === 1
              ) {
                weekdayTemTrue = true;
                this.weekdayTem = 1;
                this.radio = "2";
                this.radioForbidden = 1;
              } else if (
                items.monday === 2 ||
                items.tuesday === 2 ||
                items.wednesday === 2 ||
                items.thursday === 2 ||
                items.friday === 2 ||
                items.saturday === 2 ||
                items.sunday === 2
              ) {
                weekdayTemTrue = true;
                this.weekdayTem = 2;
                this.radio = "1";
                this.radioForbidden = 2;
              }
            }
            this.rowTableData = item.scheduleRuleList;
          }
        }
      }
    },
    scheduleRuleChange (item, week, forbidden) {
      if (week === 2) {
        if (item.monday != 1 && item.monday != 2) {
          item.monday = forbidden;
        } else if (
          this.radioForbidden !== item.monday &&
          (item.monday != 1 || item.monday != 2)
        ) {
          item.monday = forbidden;
        } else {
          item.monday = -1;
          forbidden = -1;
        }
      }
      if (week === 3) {
        if (item.tuesday != 1 && item.tuesday != 2) {
          item.tuesday = forbidden;
        } else if (
          this.radioForbidden !== item.tuesday &&
          (item.tuesday != 1 || item.tuesday != 2)
        ) {
          item.tuesday = forbidden;
        } else {
          item.tuesday = -1;
          forbidden = -1;
        }
      }
      if (week === 4) {
        if (item.wednesday != 1 && item.wednesday != 2) {
          item.wednesday = forbidden;
        } else if (
          this.radioForbidden !== item.wednesday &&
          (item.wednesday != 1 || item.wednesday != 2)
        ) {
          item.wednesday = forbidden;
        } else {
          item.wednesday = -1;
          forbidden = -1;
        }
      }
      if (week === 5) {
        if (item.thursday != 1 && item.thursday != 2) {
          item.thursday = forbidden;
        } else if (
          this.radioForbidden !== item.thursday &&
          (item.thursday != 1 || item.thursday != 2)
        ) {
          item.thursday = forbidden;
        } else {
          item.thursday = -1;
          forbidden = -1;
        }
      }
      if (week === 6) {
        if (item.friday != 1 && item.friday != 2) {
          item.friday = forbidden;
        } else if (
          this.radioForbidden !== item.friday &&
          (item.friday != 1 || item.friday != 2)
        ) {
          item.friday = forbidden;
        } else {
          item.friday = -1;
          forbidden = -1;
        }
      }
      if (week === 7) {
        if (item.saturday != 1 && item.saturday != 2) {
          item.saturday = forbidden;
        } else if (
          this.radioForbidden !== item.saturday &&
          (item.saturday != 1 || item.saturday != 2)
        ) {
          item.saturday = forbidden;
        } else {
          item.saturday = -1;
          forbidden = -1;
        }
      }
      if (week === 1) {
        if (item.sunday != 1 && item.sunday != 2) {
          item.sunday = forbidden;
        } else if (
          this.radioForbidden !== item.sunday &&
          (item.sunday != 1 || item.sunday != 2)
        ) {
          item.sunday = forbidden;
        } else {
          item.sunday = -1;
          forbidden = -1;
        }
      }
      this.scheduleRuleTrue = true;
      if (forbidden === 1) {
        this.weekdayTem = 1;
      }
      if (forbidden === 2) {
        this.weekdayTem = 2;
      }
      let tem = {
        schedulePeriodId: item.schedulePeriodId,
        weekday: week
      };
      let tem2 = {
        forbidden: Number(forbidden),
        schedulePeriodId: item.schedulePeriodId,
        weekday: week
      };
      for (let items of this.changeScheduleRuleList) {
        if (item.objectId === items.objectId) {
          if (this.weekdayTem === items.scheduleType) {
            if (items.scheduleRuleList.length != 0) {
              for (let index in items.scheduleRuleList) {
                if (
                  week === items.scheduleRuleList[index].weekday &&
                  item.schedulePeriodId ===
                  items.scheduleRuleList[index].schedulePeriodId
                ) {
                  items.scheduleRuleList.splice(index, 1);
                }
              }
              if (forbidden != -1) {
                items.scheduleRuleList.push(tem);
              }
            } else {
              items.scheduleType = this.weekdayTem;
              items.scheduleRuleList.push(tem);
            }
          } else {
            items.scheduleRuleList = [];
            items.scheduleType = this.weekdayTem;
            items.scheduleRuleList.push(tem);
          }
        }
      }
    },
    scheduleRuletrue () {
      this.batchAddScheduleObject();
    },
    batchAddScheduleObject () {
      for (let index in this.changeScheduleRuleList) {
        this.changeScheduleRuleList[index].objectType = 1;
        if (this.changeScheduleRuleList[index].scheduleRuleList.length === 0) {
          this.changeScheduleRuleList[index].scheduleType = 1;
        }
      }
      this.api.scheduleObject
        .batchAddScheduleObject(this.changeScheduleRuleList)
        .then(result => {
          if (result.success) {
            this.changeScheduleRuleList = [];
            // let ids = JSON.parse(localStorage.getItem("ids"));
            // this.api.classInfo
            //   .getClassInfoList({ classInfoPhaseIdList: ids })
            //   .then(result => {
            //     if (result.success) {
            //       let jump = result.data;
            //       localStorage.setItem("classDetail", JSON.stringify(jump));
            //     }
            //   });
            this.$message.success(result.message);
            this.getScheduleRuleList();
          } else {
            this.$message.error(result.message);
          }
        })
        .catch(error => {
          console.log(error);
        });
    },
    addScheduleRule () {
      this.scheduleRuleList.id = null;
      this.scheduleRuleList.scheduleType = this.weekdayTem;
      this.scheduleRuleList.objectId = this.objectId;
      this.scheduleRuleList.objectType = this.type;
      if (this.scheduleRuleList.scheduleRuleList.length === 0) {
        this.scheduleRuleList.scheduleType = 1;
      }
      this.api.scheduleObject
        .addScheduleObject(this.scheduleRuleList)
        .then(result => {
          if (result.success) {
            this.scheduleRuleList.scheduleRuleList = [];
            this.$message.success(result.message);
            this.getSchedule(this.objectId);
          } else {
            this.$message.error(result.message);
          }
        })
        .catch(error => {
          console.log(error);
        });
    },
    updateScheduleRule () {
      this.scheduleRuleList.id = this.ScheduleTrueId;
      this.scheduleRuleList.scheduleType = this.weekdayTem;
      this.scheduleRuleList.objectId = this.objectId;
      this.scheduleRuleList.objectType = this.type;
      if (this.scheduleRuleList.scheduleRuleList.length === 0) {
        this.scheduleRuleList.scheduleType = 1;
      }
      this.api.scheduleObject
        .updateScheduleRule(this.scheduleRuleList)
        .then(result => {
          if (result.success) {
            this.ScheduleTrue = false;
            this.scheduleRuleList.scheduleRuleList = [];
            this.$message.success(result.message);
            this.getSchedule(this.objectId);
          } else {
            this.$message.error(result.message);
          }
        })
        .catch(error => {
          console.log(error);
        });
    },

    // deleteScheduleRule(item, week, forbidden){
    //   console.log("week",week)
    //   if (this.scheduleRuleList.rules.length > 0) {
    //     for (let index in this.scheduleRuleList.rules) {
    //       if (week === this.scheduleRuleList.rules[index].weekday
    //       &&item.schedulePeriodId ===this.scheduleRuleList.rules[index].schedulePeriodId
    //       ) {
    //         console.log("index",index)
    //         this.scheduleRuleList.rules.splice(index, 1);
    //       }
    //     }
    //   }
    //   console.log("this.scheduleRuleList11111",this.scheduleRuleList)
    //   let tem = {
    //     forbidden: Number(forbidden),
    //     schedulePeriodId: item.schedulePeriodId,
    //     weekday: week
    //   };
    //   this.scheduleRuleList.rules.push(tem);
    //   console.log("this.scheduleRuleList222222",this.scheduleRuleList)
    //   this.scheduleRuleList.objectId = this.objectId;
    //   this.scheduleRuleList.type = this.type;
    //    this.api.scheduleRule
    //     .deleteScheduleRule(this.scheduleRuleList)
    //     .then(result => {
    //       if (result.success) {
    //         this.getSchedule(this.objectId);
    //       } else {
    //         this.$message.error(result.message);
    //       }
    //     })
    //     .catch(error => {
    //       console.log(error);
    //     });
    // },

    classSetting (data) {
      this.form.classInfoId = data.id;
      this.form.campusId = data.campusId;
      this.getScheduleSetting(data.id);
      this.getPlanList(data.subjectCourseId);
      this.classSttingAddDialog = true;
    },
    handleClose2 (value) {
      this.addTeachingPlanDialog = value
      this.getPlanList()
    },
    goAddTeachingPlan () {
      // this.$router.push({ path: "/addTeachingPlan" });
      this.addTeachingPlanDialog = true
      // this.classSttingAddDialog = false
      // this.getPlanList()
    },
    goAddTeacher () {
      this.$router.push({ path: "/teacher" });
    },
    goGenerateClass () {
      this.$router.push({ path: "/generateClass" });
    },

    //生成排课
    generateSimpleClassInfoSchedule () {
      if (this.generateSimpleClassInfoScheduleBlock) {
        return false;
      }
      this.generateSimpleClassInfoScheduleBlock = true;
      let obj = JSON.parse(localStorage.getItem("classDetail"));
      let ids = [];
      for (let item of obj) {
        ids.push(item.id);
      }
      this.api.classInfo
        .generateSimpleClassInfoSchedule({ ids })
        .then(result => {
          if (result.success) {
            let obj = result.data;
            localStorage.setItem("jump", JSON.stringify(obj));
            this.generateSimpleClassInfoScheduleBlock = false;
            this.goGenerateClass();
          } else {
            this.generateSimpleClassInfoScheduleBlock = false;
            this.$message.error(result.message);
          }
        });
    },

    //创建排课预设置
    addScheduleSetting () {
      this.$refs.form.validate(valid => {
        if (valid) {
          if (this.updataTrue === false) {
            if (typeof this.form.campusId == "object") {
              let index = this.form.campusId.length;
              this.form.campusId = this.form.campusId[index - 1];
            }
            this.api.scheduleSetting
              .addScheduleSetting(this.form)
              .then(result => {
                if (result.success) {
                  this.classSttingAddDialog = false;
                  this.updataTrue = false;
                  let classDetailList = JSON.parse(
                    localStorage.getItem("classDetail")
                  );
                  classDetailList.forEach(e => {
                    if (e.id == this.form.classInfoId) {
                      e.scheduleSettingState = 1;
                    }
                  });
                  this.tags = classDetailList;
                  localStorage.setItem(
                    "classDetail",
                    JSON.stringify(classDetailList)
                  );
                  this.$message.success(result.message);
                } else {
                  this.$message.error(result.message);
                }
              });
          } else {
            this.updateScheduleSetting();
          }
        }
      });
    },

    updateScheduleSetting () {
      if (typeof this.form.campusId == "object") {
        let index = this.form.campusId.length;
        this.form.campusId = this.form.campusId[index - 1];
      }
      this.api.scheduleSetting.updateScheduleSetting(this.form).then(result => {
        if (result.success) {
          this.classSttingAddDialog = false;
          this.$message.success(result.message);
          this.updataTrue = false;
        } else {
          this.$message.error(result.message);
        }
      });
    },

    //获取排课预设置详情
    getScheduleSetting (id) {
      this.updataTrue = false;
      this.form = {
        classInfoId: this.form.classInfoId,
        campusId: this.form.campusId
      };
      this.api.scheduleSetting
        .getScheduleSetting({ classInfoId: id })
        .then(result => {
          if (result.success) {
            if (result.data !== null) {
              let obj = {
                campusId: this.form.campusId,
                classInfoId: id
              };
              this.api.agentUserInfo.getTeacherList(obj).then(res => {
                if (res.success) {
                  this.teacherList = res.data;
                  if (this.teacherList.length === 0) {
                    this.$message.error("该校区暂无老师，请添加老师信息");
                  }
                  this.api.classroom
                    .getClassroomList({ campusId: this.form.campusId })
                    .then(ress => {
                      if (ress.success) {
                        this.classroomList = ress.data;
                        if (this.classroomList.length === 0) {
                          this.$message.error("该校区暂无教室，请添加教室信息");
                        }
                        this.form = result.data;
                        this.form.period = [
                          result.data.beginDate,
                          result.data.endDate
                        ];
                      } else {
                        this.$message.error(res.message);
                      }
                    });
                } else {
                  this.$message.error(res.message);
                }
              });
              this.updataTrue = true;
            } else {
              this.updataTrue = false;
              this.api.agentUserInfo
                .getTeacherList({ campusId: this.form.campusId })
                .then(res => {
                  if (res.success) {
                    this.teacherList = res.data;
                    if (this.teacherList.length === 0) {
                      this.$message.error("该校区暂无老师，请添加老师信息");
                    }
                    this.api.classroom
                      .getClassroomList({ campusId: this.form.campusId })
                      .then(ress => {
                        if (ress.success) {
                          this.classroomList = ress.data;
                          if (this.classroomList.length === 0) {
                            this.$message.error(
                              "该校区暂无教室，请添加教室信息"
                            );
                          }
                        } else {
                          this.$message.error(res.mesnsage);
                        }
                      });
                  } else {
                    this.$message.error(res.message);
                  }
                });
            }
          } else {
            this.$message.error(result.message);
          }
        });
    },

    //获取校区
    getCampusList () {
      this.api.campus
        .getCampusTree({ parentId: 1 })
        .then(result => {
          for (let item of result.data) {
            if (item.children.length != 0) {
              for (let items of item.children) {
                if (items.children.length != 0) {
                  for (let itemss of items.children) {
                    if (itemss.children.length != 0) {
                      delete itemss.children;
                    } else {
                      delete itemss.children;
                    }
                  }
                } else {
                  delete items.children;
                }
              }
            } else {
              delete item.children;
            }
          }
          this.campusList = result.data;
        })
        .catch(error => {
          console.log(error);
        });
    },
    //获取班级树
    getClassInfoTree () {
      let obj = [{ name: "班级", children: [], id: "1" }];
      this.ClassInfoTreeList = obj;
      for (let item of this.jump) {
        this.ClassInfoTreeList[0].children.push(item);
      }
      // this.api.classInfo
      //   .getClassInfoTree()
      //   .then(result => {
      //     this.ClassInfoTreeList = result.data;
      //   })
      //   .catch(error => {
      //     console.log(error);
      //   });
    },
    //获取老师树
    getTeacherTree () {
      let obj = [];
      for (let item of this.jump) {
        obj.push(item.id);
      }
      let obj2 = { classInfoIds: obj };
      this.api.scheduleObject
        .getTeacherTree(obj2)
        .then(result => {
          this.TeacherTreeList = result.data;
        })
        .catch(error => {
          console.log(error);
        });
    },
    //获取教室树
    getClassroomTree () {
      let obj = [];
      for (let item of this.jump) {
        obj.push(item.id);
      }
      let obj2 = { classInfoIds: obj };
      this.api.scheduleObject
        .getClassroomTree(obj2)
        .then(result => {
          this.ClassroomTreeList = result.data;
        })
        .catch(error => {
          console.log(error);
        });
    },

    campusIdChange () {
      if (typeof this.form.campusId === "string") {
        this.getTeacherList(this.form.campusId);
        this.getClassroomList(this.form.campusId);
      } else {
        this.form.teacherId = "";
        this.form.classroomId = "";
        let index = this.form.campusId.length;
        this.getTeacherList(this.form.campusId[index - 1]);
        this.getClassroomList(this.form.campusId[index - 1]);
      }
    },

    //获取教学计划列表
    getPlanList (id) {
      this.api.plan.getAgentPlanList({ subjectCourseId: id }).then(result => {
        if (result.success) {
          this.planList = result.data;
          if (this.planList.length === 0) {
            this.$message.error("该科目暂无教学计划，请添加教学计划");
          }
        } else {
          this.$message.error(result.message);
        }
      });
    },

    //获取老师列表
    getTeacherList (id) {
      this.api.agentUserInfo.getTeacherList({ campusId: id }).then(result => {
        if (result.success) {
          this.teacherList = result.data;
          if (this.teacherList.length === 0) {
            this.$message.error("该校区暂无老师，请添加老师信息");
          }
        } else {
          this.$message.error(result.message);
        }
      });
    },

    //获取教室列表
    getClassroomList (id) {
      this.api.classroom.getClassroomList({ campusId: id }).then(result => {
        if (result.success) {
          this.classroomList = result.data;
          if (this.classroomList.length === 0) {
            this.$message.error("该校区暂无教室，请添加教室信息");
          }
        } else {
          this.$message.error(result.message);
        }
      });
    },
    //获取日历课程
    classroomCalendar (beginDate, endDate) {
      let obj = {};
      // let classInfoIds = [];
      // for (let item of JSON.parse(localStorage.getItem("classDetail"))) {
      //   classInfoIds.push(item.id);
      // }
      if (beginDate) {
        obj = {
          // classInfoIds: classInfoIds,
          beginDate: beginDate,
          endDate: endDate
        };
      } else {
        obj = {
          // classInfoIds: classInfoIds,
          beginDate: moment()
            .month(moment().month())
            .startOf("month")
            .format("YYYY-MM-DD"),
          endDate: moment()
            .month(moment().month())
            .endOf("month")
            .format("YYYY-MM-DD")
        };
      }

      this.api.classInfo.classroomCalendar(obj).then(result => {
        if (result.success) {
          this.calendarData = result.data;
          for (let item of this.calendarData) {
            if (item.data) {
              if (item.data.length > 0) {
                let index = item.data.length;
                item.classInfoCount = index;
              }
            }
          }
        } else {
          this.$message.error(result.message);
        }
      });
    },
    getScheduleRule () {
      this.api.scheduleRule.getScheduleRule().then(result => {
        this.scheduleRuleTrue = true;
      });
    },
    calendarChange () { },
    rowMouseMove (tuesdayTem) {
      tuesdayTem = 1;
    },
    rowMouseLeave (tuesdayTem) {
      tuesdayTem = -1;
    },
    handleClose (tag) {
      let mes = "将会移除该教学计划，是否确认移除？";
      if (this.tags.length == 1) {
        mes = "该班级为此次排课唯一班级，移除后将返回上一页面！";
      }
      this.$confirm(mes, "系统消息", {
        type: "warning"
      }).then(() => {
        this.tags.splice(this.tags.indexOf(tag), 1);
        localStorage.setItem("classDetail", JSON.stringify(this.tags));
        if (this.tags.length == 0) {
          this.$router.go(-1);
        }
      });
    },
    handleClick (tab, event) {
      if (tab.name === "first") {
        this.classroomCalendar(
          this.currentWeekDate[0],
          this.currentWeekDate[1]
        );
      }
      if (tab.name === "second") {
        this.classroomCalendar();
      }
    },
    lastWeek () {
      this.currentWeekDate = [
        moment(this.currentWeekDate[0])
          .subtract(7, "days")
          .format("YYYY-MM-DD"),
        moment(this.currentWeekDate[1])
          .subtract(7, "days")
          .format("YYYY-MM-DD")
      ];
      this.classroomCalendar(this.currentWeekDate[0], this.currentWeekDate[1]);
    },
    nextWeek () {
      this.currentWeekDate = [
        moment(this.currentWeekDate[0])
          .subtract(-7, "days")
          .format("YYYY-MM-DD"),
        moment(this.currentWeekDate[1])
          .subtract(-7, "days")
          .format("YYYY-MM-DD")
      ];
      this.classroomCalendar(this.currentWeekDate[0], this.currentWeekDate[1]);
    },
    nowWeek () {
      this.currentWeekDate = [
        moment(this.nowTime)
          .startOf("week")
          .subtract(-1, "days")
          .format("YYYY-MM-DD"),
        moment(this.nowTime)
          .endOf("week")
          .subtract(-1, "days")
          .format("YYYY-MM-DD")
      ];
      this.classroomCalendar(this.currentWeekDate[0], this.currentWeekDate[1]);
    }
  },
  computed: {},
  mounted () {
    this.getData();
    this.classroomCalendar();
  },
  //   created() {
  //   this.$nextTick(function() {

  //     this.$data.ClassInfoTreeList.forEach(row => {
  //       // debugger
  //       if (row.show) {
  //         this.$refs.treeBox.setCurrentKey(row.id);
  //         this.$refs.treeBox.store.nodesMap[row.id].expanded = true;
  //       }
  //     });
  //   });
  // },
  // created() {
  //   this.$nextTick(function() {
  //     this.$refs.ClassInfoTreeList.setCurrentKey(0); //"treeList"是你自己在树形控件上设置的 ref="treeList" 的名称
  //   });
  // },
  watch: {
    currentDate (nVal) {
      let beginDate = moment(this.currentDate)
        .startOf("month")
        .format("YYYY-MM-DD");
      let endDate = moment(this.currentDate)
        .endOf("month")
        .format("YYYY-MM-DD");
      let beginDate2 = moment(this.currentWeekDate)
        .startOf("week")
        .subtract(-1, "days")
        .format("YYYY-MM-DD");
      let endDate2 = moment(this.currentWeekDate)
        .endOf("week")
        .subtract(-1, "days")
        .format("YYYY-MM-DD");
      this.classroomCalendar(beginDate, endDate);
    },
    rowDialogVisible: function (newVal) {
      if (!newVal) {
        this.scheduleRuleList.scheduleRuleList = [];
      } else {
      }
    },
    classSttingAddDialog: function (newVal) {
      if (!newVal) {
        this.$refs.form.resetFields();
        this.form.campusId = "";
      } else {
        // this.getCampusList();
      }
    },
    innerVisible: function (newVal) {
      if (!newVal) {
        this.getPeriodTrue = false;
        this.periodForm = {
          beginTime: "",
          endTime: ""
        };
      } else {
      }
    }
    // rowTableData: function(newVal, oldVal) {
    //   console.log("3456", newVal);
    //   console.log("3456", oldVal);
    // },
  }
};
</script>
<style scoped>
.addClass-buttonType {
  display: flex;
  justify-content: center;
  padding-left: 10px;
  padding-right: 10px;
  cursor: pointer;
  background: #409eff;
  height: 32px;
  color: #fff;
  line-height: 32px;
  text-align: center;
  font-size: 13px;
  border-radius: 4px;
  width: 200px;
  margin-right: 20px;
  margin-bottom: 10px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.addTeachingPlanDialog {
  margin: -20px;
}
.addClass-buttonType2 {
  background: #acd2f8;
}
.addClass-name {
  width: 170px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.addClass-bar {
  height: 20px;
  width: 20px;
  text-align: center;
  line-height: 20px;
  color: #fff;
  border-radius: 50%;
  /* border: 4px solid #fff; */
  background-color: #409eff;
}
.addClass-buttonBox {
  display: flex;
  flex-wrap: wrap;
}
.icon-close-style {
  float: right;
  line-height: 32px;
  margin-right: 10px;
  cursor: pointer;
}
.addClass-gupai {
  display: flex;
  position: relative;
  height: 0px;
  top: -68px;
  left: 100px;
}
.addClass-tag {
  margin-right: 20px;
  margin-top: 20px;
  margin-bottom: 20px;
  cursor: pointer;
}
.addClass-button {
  margin-top: 20px;
  margin-bottom: 20px;
}
.addClass-generate {
  /* position: fixed;
  right: 0px; */
  float: right;
}
.rowStyle1 {
  width: 20px;
  height: 20px;
  background-color: rgba(36, 210, 181, 1);
  border-radius: 50%;
  margin: auto;
  margin-top: 12px;
}
.rowStyle2 {
  width: 20px;
  height: 20px;
  background-color: rgba(255, 85, 85, 1);
  border-radius: 50%;
  margin: auto;
  margin-top: 12px;
}
.rowStyle3 {
  width: 15px;
  height: 15px;
  /* margin-left: 10px; */
  background-color: rgba(36, 210, 181, 1);
  border-radius: 50%;
  margin-top: 10px;
}
.rowStyle3-text {
  line-height: 15px;
  margin-left: 2px;
  margin-top: 10px;
}
.rowStyle4 {
  width: 15px;
  height: 15px;
  background-color: rgba(255, 85, 85, 1);
  border-radius: 50%;
  margin-left: 30px;
  margin-top: 10px;
}
.addClass-icon {
  font-size: 16px;
  color: #4d94ff;
  margin-right: 10px;
  margin-left: 10px;
}
.time-selectType {
  text-align: center;
  width: 100%;
  line-height: 40px;
}
.classInfoType {
  cursor: pointer;
  margin-left: 22px;
  margin-top: 10px;
}
.classManage-study1 {
  height: 20px;
  line-height: 20px;
  padding-left: 5px;
  color: #4d94ff;
  margin-top: 2px;
  border-left: 2px solid rgba(77, 148, 255, 1);
  background-color: rgba(77, 148, 255, 0.0980392156862745);
  overflow: hidden;
}
.classManage-study2 {
  height: 20px;
  line-height: 20px;
  padding-left: 5px;
  color: #4d94ff;
  padding-right: 10px;
  margin-top: 2px;
  background-color: rgba(77, 148, 255, 0.0980392156862745);
  overflow: hidden;
  position: absolute;
  bottom: 2px;
  right: 8px;
}
.classManage-study3 {
  height: 20px;
  line-height: 20px;
  padding-left: 5px;
  color: #4d94ff;
  padding-right: 10px;
  margin-top: 2px;
  background-color: rgba(77, 148, 255, 0.0980392156862745);
  overflow: hidden;
  float: right;
}
.calendar-solt1 {
  font-size: 16px;
  color: #455a64;
  font-weight: 600;
}
.calendar-solt2 {
  font-size: 13px;
  margin-top: 10px;
}
.calendar-button {
  float: right;
}
.calendar-button1 {
  height: 28px;
  line-height: 10px;
}
.tooltip-height {
  max-height: 100px;
  overflow-y: auto;
  margin: 0px;
}
.table-row {
  display: flex;
  height: 45px;
}
.table-cell {
  width: 100%;
  height: 100%;
}
.span-ellipsis {
  width: 100%;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  display: block;
}
</style>
<style lang="less">
.addClass {
  .el-calendar-table .el-calendar-day {
    min-height: 150px;
    position: relative;
    overflow-y: auto;
  }
  .el-table tbody tr:hover > td {
    background-color: #ffffff !important;
  }
  .el-table .cell {
    padding: 0px;
  }
  .el-table td,
  .el-table th {
    padding: 0px;
    height: 45px;
  }
  .el-table--enable-row-transition .el-table__body {
    .table-row:hover {
      background-color: rgb(250, 250, 250) !important;
    }
  }
}
// .el-tree-node:focus > .el-tree-node__content {
//   color: #409EFF;
// }

/*高亮当前选中的树节点*/
// .el-tree-node.is-current > .el-tree-node__content {
//   color: #409eff;
// }
</style>



// WEBPACK FOOTER //
// src/components/classManage/addClass.vue